import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Breakpoint, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { ProfileDetails } from '../../components/account/profile-details/ProfileDetails';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
export var AccountProfileDetailsTabPanes;
(function (AccountProfileDetailsTabPanes) {
    AccountProfileDetailsTabPanes[AccountProfileDetailsTabPanes["PROFILE_DETAILS"] = 0] = "PROFILE_DETAILS";
    AccountProfileDetailsTabPanes[AccountProfileDetailsTabPanes["CONNECTED_ACCOUNTS"] = 1] = "CONNECTED_ACCOUNTS";
})(AccountProfileDetailsTabPanes || (AccountProfileDetailsTabPanes = {}));
const AccountProfileDetailsContainer = props => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    return (_jsxs(Box, { testId: "account-details", marginInline: { base: '-4', md: '0' }, paddingBlockEnd: { base: '10', md: '12', lg: '14' }, children: [_jsx(Breakpoint, { from: "lg", children: _jsx(Box, { paddingBlockEnd: { lg: '6' }, children: _jsx(TextAlpha, { as: "h2", variant: "headingS", children: t('profileDetails.heading') }) }) }), _jsx(ProfileDetails, Object.assign({}, props))] }));
};
export default AccountProfileDetailsContainer;
